<template>
  <app-report>
    <app-widget
      flat
      class-widget="sm10 offset-sm1 xs12"
    >
      <div slot="widget-content">
        <app-report-header
          :title="`${industriaDoCliente.cliente.nome} (${industriaDoCliente.industria.nome_fantasia})`"
        />
        <div
          class="d-flex flex-row justify-center"
          v-if="openChart"
        >
          <div class="d-flex flex-column">
            <app-line-chart
              sbs
              :styles="{height: '240px', position: 'relative'}"
              class="ma-auto"
              scale-label-x="Data da coleta"
              scale-attribute="laudo_data_coleta"
              dataset-label="Gordura"
              dataset-attribute="laudo_gordura"
              pattern-scale-y="gordura"
              :scale-attribute-jurisdiction="true"
            />
            <app-line-chart
              sbs
              :styles="{height: '240px', position: 'relative'}"
              class="ma-auto"
              scale-label-x="Data da coleta"
              scale-attribute="laudo_data_coleta"
              dataset-label="CCS"
              dataset-attribute="laudo_ccs"
              pattern-scale-y="ccs"
              :scale-attribute-jurisdiction="true"
            />
          </div>
          <div class="d-flex flex-column">
            <app-line-chart
              sbs
              :styles="{height: '240px', position: 'relative'}"
              class="ma-auto"
              scale-label-x="Data da coleta"
              scale-attribute="laudo_data_coleta"
              dataset-label="CPP"
              dataset-attribute="laudo_cpp"
              pattern-scale-y="cpp"
              :scale-attribute-jurisdiction="true"
            />
            <app-line-chart
              sbs
              :styles="{height: '240px', position: 'relative'}"
              class="ma-auto"
              scale-label-x="Data da coleta"
              scale-attribute="laudo_data_coleta"
              dataset-label="Volume"
              dataset-attribute="laudo_producao"
              :scale-attribute-jurisdiction="true"
            />
          </div>
        </div>
        <app-report-table class="mt-4">
          <thead>
            <tr>
              <th class="text-left">
                Competência
              </th>
              <th class="text-center">
                Amostra
              </th>
              <th class="text-center">
                Gordura
              </th>
              <th class="text-center">
                Proteína
              </th>
              <th class="text-center">
                Lactose
              </th>
              <th class="text-center">
                Sólidos
              </th>
              <th class="text-center">
                ESD
              </th>
              <th class="text-center">
                CCS
              </th>
              <th class="text-center">
                CPP
              </th>
              <th class="text-center">
                Volume
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="d-print-table-row"
              v-for="item in relatorio"
              :key="item.id"
            >
              <td
                v-text="$options.filters.jurisdiction(item.laudo_data_coleta)"
              />
              <td
                class="text-center"
                v-text="item.laudo_amostra_numero"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_gordura)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_proteina)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_lactose)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_solidos)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_esd)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_ccs)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_cpp)"
              />
              <td
                class="text-center"
                v-text="$options.filters.decimal(item.laudo_producao)"
              />
            </tr>
          </tbody>
        </app-report-table>
        <app-lista-geometrica />
      </div>
    </app-widget>
  </app-report>
</template>
<script>
import AppReport from '@/components/layouts/AppReport'
import AppWidget from '@/components/AppWidget'
import AppReportHeader from '@/components/AppReportHeader'
import AppLineChart from '@/components/AppLineChart'
import AppReportTable from '@/components/AppReportTable'
import AppListaGeometrica from '@/components/AppListaGeometrica'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppReport,
    AppWidget,
    AppReportHeader,
    AppReportTable,
    AppListaGeometrica,
    AppLineChart
  },
  computed: {
    ...mapGetters(['relatorio', 'cliente', 'industriaDoCliente', 'openChart'])
  }
}
</script>
